/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setIssuedCardLock} from '../api'

export const useMutationSetIssuedCardLock = createReactQueryMutationHook('setIssuedCardLock', setIssuedCardLock)
